/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerCreateModel } from '../../models/customer-create-model';
import { CustomerResponse } from '../../models/customer-response';

export interface PostApiCustomerV1Create$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * Dati per la creazione dell'customere.
     */
    body?: CustomerCreateModel
}

export function postApiCustomerV1Create$Json(http: HttpClient, rootUrl: string, params?: PostApiCustomerV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiCustomerV1Create$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerResponse>;
    })
  );
}

postApiCustomerV1Create$Json.PATH = '/private/v1/customers/create';
